import React, {ReactElement} from "react"
import HorizontalSeparator from "../components/HorizontalSeparator"

import styles from "../styles/MorePaymentOptionsButton.module.scss"


type PayMarkId = "apple_pay"|"google_pay"|"paypal"|"visa"
interface PayMarkMetadata {
  id: PayMarkId
  url: string
  title: string
}
const MARK_URL_BASE = "https://frontend-assets.buildbox.com"
const MARK_METADATA:PayMarkMetadata[] = [
  {
    id: "apple_pay",
    url: `${MARK_URL_BASE}/apple_pay_mark.svg`,
    title: "apple_pay"
  },
  {
    id: "google_pay",
    url: `${MARK_URL_BASE}/google_pay_mark.png`,
    title: "Google Pay"
  },
  {
    id: "paypal",
    url: `${MARK_URL_BASE}/paypal_mark.jpg`,
    title: "Paypal"
  },
  // {
  //   id: "visa",
  //   url: `${MARK_URL_BASE}/visa_mark.png`,
  //   title: "Visa"
  // }
]

export function renderImg({id, url, title}:PayMarkMetadata):ReactElement {
  return (
    <img
      key={id}
      className={styles[id]}
      src={url}
      alt={title}
    />
  )
}

type Props = {
  handleToXsollaCheckout: ()=> void
}

export function MorePaymentOptionsButton({ handleToXsollaCheckout }: Props): ReactElement {
  return (
    <>
      <div className={styles.morePaymentsContainer}>
        <div className={styles.separatorDiv}>
          <HorizontalSeparator text="OR" />
        </div>
        <p className={styles.morePaymentsText}>We support 100+ payment methods!</p>
        <div className={styles.morePaymentOptions} onClick={handleToXsollaCheckout}>
          <div className={styles.marks}>
            {MARK_METADATA.map(renderImg)}
            <p className={styles.plusMore}>+ more</p>
          </div>
          <div className={styles.text}>MORE PAYMENT OPTIONS</div>
        </div>
      </div>
    </>
  );
}
